"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearDiv = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var ClearBefore = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t&::before {\n\t\tclear: both;\n\t\tcontent: ' ';\n\t\tdisplay: table;\n\t\twidth: 100%;\n\t}\n"], ["\n\t&::before {\n\t\tclear: both;\n\t\tcontent: ' ';\n\t\tdisplay: table;\n\t\twidth: 100%;\n\t}\n"])));
exports.ClearDiv = styled_components_1.default.div.attrs({ className: 'clear' })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", ";\n\t&::before {\n\t\theight: ", ";\n\t}\n\t&::after {\n\t\tclear: both;\n\t\tcontent: ' ';\n\t\tdisplay: table;\n\t\twidth: 100%;\n\t\theight: ", ";\n\n\t\t@media (max-width: 768px) {\n\t\t\theight: ", ";\n\t\t}\n\t}\n"], ["\n\t", ";\n\t&::before {\n\t\theight: ", ";\n\t}\n\t&::after {\n\t\tclear: both;\n\t\tcontent: ' ';\n\t\tdisplay: table;\n\t\twidth: 100%;\n\t\theight: ", ";\n\n\t\t@media (max-width: 768px) {\n\t\t\theight: ", ";\n\t\t}\n\t}\n"])), function (props) { return (props.clearBefore ? ClearBefore : null); }, function (props) { return (props.clearBefore ? props.clearBefore : null); }, function (props) { return (props.clearHeight ? props.clearHeight : '20px'); }, function (props) { return (props.clearHeightMobile ? props.clearHeightMobile : '0px'); });
exports.ClearDiv.displayName = 'ClearDiv';
var templateObject_1, templateObject_2;
